/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderSchema } from "./mobileOrderSchema.ts";

export const paginatedMobileOrderListSchema = z.object({
	page: z.int(),
	page_size: z.int(),
	total: z.int(),
	total_pages: z.int(),
	results: z.array(mobileOrderSchema),
});
